module.exports = __webpack_public_path__ + "img/solution-8.77d81efd.jpg";